export default __webpack_public_path__ + "static/media/contact-img-1.2b128f8b.png";